<nav class="navigation">
  <app-progress-bar
    [progressRate]="getProgressRate()"
    [progressStartAt]="getProgressStartAt()"
    [color]="progressBarColor"></app-progress-bar>
  <div class="navigation-wrapper">
    <div class="navigation-routes">
      <div
        class="navigation-route"
        *ngFor="let route of navigationRoutes; trackBy: trackByRoute"
        [routerLink]="route.url">
        <div class="icon-container">
          <i [class]="route.iconClass"></i>
          <span
            class="notification-badge"
            *ngIf="route.title === 'Notifs.' && unreadNotificationCount > 0">
            {{ unreadNotificationCount }}
          </span>
        </div>
        <p>{{ route.title }}</p>
      </div>
    </div>
  </div>
</nav>
